<script>
import {Tooltip} from "element-ui";
export default {
  name: "CustomElTooltip",
  extends: Tooltip,
  props: {
    closeAutoShow: {
      default: false,
      type: Boolean
    }
  },
  methods: {
   show(){
    let elm = this.referenceElm;
    let { scrollWidth, clientWidth, scrollHeight, clientHeight } = elm;
    if(this.closeAutoShow || scrollWidth > clientWidth || scrollHeight > clientHeight){
      this.setExpectedState(true);
      this.handleShowPopper();
    }
   }
  }
};
</script>